export default {
	beforeMount(element, binding) {
		if (typeof ResizeObserver !== 'function') return

		const resizeObserver = new ResizeObserver(entries => {
			// Firefox implements `contentBoxSize` as a single content rect, rather than an array
			for (let entry of entries) {
				const contentBoxSize = Array.isArray(entry.contentBoxSize)
					? entry.contentBoxSize[0]
					: entry.contentBoxSize
				binding.value(contentBoxSize)
			}
		})

		element.__vueResizeObserver__ = resizeObserver
		resizeObserver.observe(element)
	},
	beforeUnmount(element) {
		if (!element.__vueResizeObserver__) return

		element.__vueResizeObserver__.unobserve(element)
	},
}
